var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.627,
    height: 16,
    viewBox: "0 0 12.627 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-Apr-15-17-32-02",
    transform: "translate(-439.5 452.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M38.191-536.941a1.228,1.228,0,0,0-.629.632c-.059.174-.063.375-.063,7.326v7.145l.086.181a1,1,0,0,0,.517.533l.221.109,5.413.01c5.956.01,5.644.02,5.946-.191a1.025,1.025,0,0,0,.375-.461c.066-.148.069-.2.069-4.735v-4.583H47.882a19.881,19.881,0,0,1-2.46-.049,1.714,1.714,0,0,1-1.235-1.2,16.53,16.53,0,0,1-.053-2.479V-537l-2.888,0A21.308,21.308,0,0,0,38.191-536.941Z",
    transform: "translate(402 84.927)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M277-515.46c0,2.228,0,2.2.206,2.338a8.319,8.319,0,0,0,2.167.075c1.137,0,2.068,0,2.068-.018s-2.015-2.043-3.773-3.777L277-517.5Z",
    transform: "translate(170.685 65.427)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy_white.5b102d97e75706562421c431b76f12d9.svg";
export { ForwardRef as ReactComponent };